import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const barcodeService = {
  // Generate barcodes for a product (with or without variants)
  generateBarcodes: async (productId, data) => {
    try {
      const requestData = {
        product_id: productId,
        barcode_type: 'UPC',
        ...data
      };

      const response = await axios.post(`${API_BASE_URL}${API_URLS.GENERATE_BARCODES}`, requestData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get barcode history for a product
  getProductBarcodes: async (productId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.PRODUCT_BARCODES(productId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Scan barcode
  scanBarcode: async (barcodeNumber, saleId = null) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.SCAN_BARCODE}`, {
        barcode_number: barcodeNumber,
        sale_id: saleId
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get barcode by number
  getBarcode: async (barcodeNumber) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.GET_BARCODE(barcodeNumber)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default barcodeService;